import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-account",
  "use": "icon-account-usage",
  "viewBox": "0 0 22 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 24\" id=\"icon-account\"><circle cx=\"11\" cy=\"5\" r=\"4.5\" stroke=\"currentColor\" /><path d=\"M21.329 22.1c.13.718-.469 1.4-1.327 1.4H1.998C1.14 23.5.54 22.818.67 22.1c.894-4.892 5.18-8.6 10.329-8.6 5.15 0 9.435 3.708 10.329 8.6Z\" stroke=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol